<template>
    <div class="formInput__wrapper">
        <label
            :for="fieldId"
            class="formRadio">
            <input
                :id="fieldId"
                :ref="fieldId"
                type="radio"
                :name="fieldName"
                :value="fieldValue"
                class="formRadio__input"
                :class="fieldClasses"
                :required="fieldRequired"
                :disabled="fieldDisabled"
                :aria-checked="fieldChecked ? fieldChecked : 'false'"
                :checked="fieldChecked"
                :aria-invalid="`${ ariaInvalidStatus }`"
                :data-gtm="dataGtm"
                @change="handleChange" />
            <span
                v-if="fieldLabel"
                class="formRadio__labelText"
                :class="labelClasses">
                {{ fieldLabel }}
            </span>
            <slot></slot>
            <span
                v-if="fieldRequired === true"
                class="formRadio__required">
                <span class="visually-hidden">
                    {{ trans('LABEL_TEXT_SR_REQUIRED') }}
                </span>
            </span>
        </label>
    </div>
</template>

<script>
    import Translator from 'tools/trans';
    import formBaseProps from 'mixins/formBaseMixin';
    import formInputProps from 'mixins/formInputMixin';

    export default {
        mixins: [formBaseProps, formInputProps],
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            checked: { type: Boolean, default: null },
            dataGtm: { type: String, default: null },
            labelClasses: { type: String, default: null },
        },
        data() {
            return {
                fieldChecked: this.checked !== null ? this.checked : this.getCheckedStatus(this.field),
            };
        },
        watch: {
            checked(value) {
                this.fieldChecked = value !== null ? value : this.getCheckedStatus(this.field);
            },
        },
        methods: {
            trans: Translator.trans,
            handleChange(event) {
                this.$emit('change', event.currentTarget.checked);
            },
            getCheckedStatus(field) {
                if (field.attr && field.attr.checked === true) {
                    return true;
                }

                return field.checked === true;
            },
        },
    };
</script>
